"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlainText = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * 提取子结点中纯文本
 */
function getPlainText(node) {
    var text = [];
    var traverse = function (children) {
        if (!children) {
            return;
        }
        react_1.default.Children.forEach(children, function (child) {
            if (react_1.default.isValidElement(child) && child.props.children) {
                traverse(child.props.children);
            }
            else if (typeof child === "number" || typeof child === "string") {
                text.push(String(child));
            }
        });
    };
    traverse(node);
    return text.join(" ");
}
exports.getPlainText = getPlainText;
//# sourceMappingURL=getPlainText.js.map